class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) {
      this.remove();
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadFrom(this.dataset.url);
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }

  loadFrom(url) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (!recommendations) {
          this.remove();
          return;
        }

        const currentId = this.dataset.currentProductId || '';
        const currentVendor = this.dataset.currentVendor || '';
        const currentSeries = this.dataset.currentSeries || '';
        const currentColor = this.dataset.currentColor || '';
        const currentType = this.dataset.currentType || '';
        const limit = Number.parseInt(this.dataset.productsToShow || '10', 10);
        const seenSeries = new Set();
        let kept = 0;

        recommendations.querySelectorAll('.swiper-slide').forEach((slide) => {
          const productId = slide.dataset.productId || '';
          const vendor = slide.dataset.productVendor || '';
          const series = slide.dataset.productSeries || '';
          const color = slide.dataset.productColor || '';
          const type = slide.dataset.productType || '';
          const shouldRemove =
            productId === currentId ||
            !vendor ||
            vendor === currentVendor ||
            !series ||
            series === currentSeries ||
            !color ||
            color !== currentColor ||
            !type ||
            type !== currentType ||
            seenSeries.has(series) ||
            kept >= limit;

          if (shouldRemove) {
            slide.remove();
            return;
          }

          seenSeries.add(series);
          kept += 1;
        });

        if (kept === 0) {
          this.remove();
          return;
        }

        this.innerHTML = recommendations.innerHTML;
        if (typeof skAnimation === 'function') {
          setTimeout(() => skAnimation(), 300);
        }
      })
      .catch((error) => {
        console.error(error);
        this.remove();
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
